function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.894 13.132c-2.92 0-5.724 1.17-7.069 3.397h-.038V8.302c0-1.056-.883-1.962-1.998-1.962-1.075 0-1.92.905-1.92 1.962v23.245c0 1.057.845 1.963 1.92 1.963a1.966 1.966 0 0 0 1.998-1.963v-1.32c1.345 2.264 4.226 3.471 7.03 3.471 5.532 0 10.22-4.037 10.22-10.302 0-6.301-4.573-10.264-10.143-10.264zm6.108 10.227c0 3.886-2.88 6.603-6.492 6.603-3.573 0-6.646-2.377-6.684-6.603 0-4.227 3.457-6.453 6.684-6.453 3.611 0 6.492 2.528 6.492 6.453zM80.56 33.736c2.804 0 5.724-1.245 7.069-3.472v1.359c0 1.056.845 1.962 1.92 1.962a1.966 1.966 0 0 0 1.998-1.962V15.359c0-1.057-.884-1.963-1.998-1.963-1.075 0-1.92.906-1.92 1.963v1.207c-1.345-2.264-4.265-3.396-7.07-3.396-5.531 0-10.218 3.962-10.218 10.264 0 6.226 4.725 10.302 10.219 10.302zm-6.147-10.377c0-3.925 2.92-6.453 6.531-6.453 3.227 0 6.646 2.264 6.684 6.453 0 4.188-3.111 6.603-6.684 6.603-3.611 0-6.53-2.717-6.53-6.603z",
  fill: "#2C3339"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.15 30.34c2.036 0 3.534-1.057 3.534-2.604 0-1.434-1.152-2.151-2.651-2.49l-2.766-.642c-3.38-.906-5.416-2.528-5.416-5.66 0-3.246 2.958-5.774 7.03-5.774 2.612 0 5.148.943 6.339 3.208.153.301.23.641.23.905 0 1.283-1.229 1.736-1.844 1.736-.576 0-.999-.302-1.421-.83-.922-1.17-1.921-1.66-3.189-1.66-1.882 0-3.15 1.094-3.15 2.565 0 1.284 1.229 2 2.536 2.265l2.958.717c4.187 1.018 5.224 3.509 5.224 5.735 0 3.66-3.611 5.925-7.798 5.925-3.112 0-6.3-1.698-7.223-4.717-.038-.226-.076-.415-.076-.604 0-1.019.998-1.51 1.882-1.51.691 0 1.383.34 1.69 1.095.5 1.434 2.075 2.34 4.111 2.34z",
  fill: "#2C3339"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.942 24.906h14.791c.807 0 1.536-.642 1.536-1.51 0-6.264-4.264-10.226-9.988-10.226-5.724 0-10.295 3.962-10.295 10.226 0 6.227 4.571 10.34 10.295 10.34 3.266 0 6.3-1.17 8.221-3.623.615-.679.423-1.811-.345-2.415-.769-.566-1.883-.302-2.613.49-1.383 1.473-2.689 2.076-5.109 2.076-3.381 0-6.032-2.075-6.493-5.358zm6.378-8.302c3.227 0 5.647 2 6.108 5.283h-12.486c.5-3.283 3.074-5.283 6.378-5.283z",
  fill: "#2C3339"
});

var _ref4 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 20.822,
  cy: 20.075,
  rx: 20.13,
  ry: 19.774,
  fill: "#EA4235"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.784 33.677c-4.743 0-8.913-3.758-8.913-8.492 0-2.893 1.377-5.223 3.979-6.575-1.492-1.428-2.372-2.856-2.372-4.96 0-4.058 3.175-7.214 7.306-7.214s7.344 3.156 7.344 7.214c0 2.104-.918 3.532-2.41 4.96 2.602 1.352 3.979 3.682 3.979 6.575-.039 4.734-4.17 8.492-8.913 8.492zm0-12.512c-2.257 0-4.093 1.803-4.093 4.02 0 2.217 1.836 4.02 4.093 4.02 2.257 0 4.093-1.803 4.093-4.02 0-2.217-1.836-4.02-4.093-4.02zm-2.792-7.44c0-1.503 1.224-2.818 2.792-2.818a2.831 2.831 0 0 1 2.83 2.818c0 1.503-1.3 2.78-2.83 2.78s-2.792-1.277-2.792-2.78z",
  fill: "#fff"
});

var Svg8BaseLogo = function Svg8BaseLogo(props) {
  return React.createElement("svg", _extends({
    width: 132,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/8base-logo.34b8aa8a.svg";
export { Svg8BaseLogo as ReactComponent };